"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestConfigMilestoneToJSON = exports.QuestConfigMilestoneFromJSONTyped = exports.QuestConfigMilestoneFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function QuestConfigMilestoneFromJSON(json) {
    return QuestConfigMilestoneFromJSONTyped(json, false);
}
exports.QuestConfigMilestoneFromJSON = QuestConfigMilestoneFromJSON;
function QuestConfigMilestoneFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'logicType': (0, _1.LogicModuleTypeFromJSON)(json['logicType']),
        'targetAmount': json['targetAmount'],
        'sessionAmount': !(0, runtime_1.exists)(json, 'sessionAmount') ? undefined : json['sessionAmount'],
        'sessionCadence': !(0, runtime_1.exists)(json, 'sessionCadence') ? undefined : (0, _1.QuestResetFromJSON)(json['sessionCadence']),
        'triggerEvent': (0, _1.EventValidatorFromJSON)(json['triggerEvent']),
        'resetEvent': !(0, runtime_1.exists)(json, 'resetEvent') ? undefined : (0, _1.EventValidatorFromJSON)(json['resetEvent']),
        'finishEvent': !(0, runtime_1.exists)(json, 'finishEvent') ? undefined : (0, _1.EventValidatorFromJSON)(json['finishEvent']),
        'sources': !(0, runtime_1.exists)(json, 'sources') ? undefined : (json['sources'].map(_1.DataSourceFromJSON)),
        'rewardConfigIds': !(0, runtime_1.exists)(json, 'rewardConfigIds') ? undefined : json['rewardConfigIds'],
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'description': !(0, runtime_1.exists)(json, 'description') ? undefined : json['description'],
        'gameId': !(0, runtime_1.exists)(json, 'gameId') ? undefined : json['gameId'],
        'progressionOrder': !(0, runtime_1.exists)(json, 'progressionOrder') ? undefined : json['progressionOrder'],
        'rewardPer': !(0, runtime_1.exists)(json, 'rewardPer') ? undefined : json['rewardPer'],
    };
}
exports.QuestConfigMilestoneFromJSONTyped = QuestConfigMilestoneFromJSONTyped;
function QuestConfigMilestoneToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'logicType': (0, _1.LogicModuleTypeToJSON)(value.logicType),
        'targetAmount': value.targetAmount,
        'sessionAmount': value.sessionAmount,
        'sessionCadence': (0, _1.QuestResetToJSON)(value.sessionCadence),
        'triggerEvent': (0, _1.EventValidatorToJSON)(value.triggerEvent),
        'resetEvent': (0, _1.EventValidatorToJSON)(value.resetEvent),
        'finishEvent': (0, _1.EventValidatorToJSON)(value.finishEvent),
        'sources': value.sources === undefined ? undefined : (value.sources.map(_1.DataSourceToJSON)),
        'rewardConfigIds': value.rewardConfigIds,
        'name': value.name,
        'description': value.description,
        'gameId': value.gameId,
        'progressionOrder': value.progressionOrder,
        'rewardPer': value.rewardPer,
    };
}
exports.QuestConfigMilestoneToJSON = QuestConfigMilestoneToJSON;
